import React from 'react';
import styles from './VinylSpinner.module.css';
import { withTheme, Theme } from '@material-ui/core';

export interface VinylSpinnerProps {
  theme?: Theme;
}

export interface VinylSpinnerState {}

class VinylSpinner extends React.Component<VinylSpinnerProps, VinylSpinnerState> {
  constructor(props: VinylSpinnerProps) {
    super(props);
  }

  render() {
    const paddingStyle = { padding: '5px' } as React.CSSProperties;
    const color1 = this.props.theme!.palette.primary.dark;
    const color2 = this.props.theme!.palette.primary.main;
    return (
      <div style={paddingStyle} className={styles.spinner}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 375 375"
        >
          <defs>
            <clipPath id="_clipPath_xBsTzgo1bKKTJ3HZhsS6av3xVCaYfzIZ">
              <rect width="375" height="375" />
            </clipPath>
          </defs>
          <g clipPath="url(#_clipPath_xBsTzgo1bKKTJ3HZhsS6av3xVCaYfzIZ)">
            <rect width="375" height="375" fill="rgb(217,106,106)" fillOpacity="0" />
            <g>
              <g>
                <path
                  d=" M 0 187.5 C 0 84.016 84.016 0 187.5 0 C 290.984 0 375 84.016 375 187.5 C 375 290.984 290.984 375 187.5 375 C 84.016 375 0 290.984 0 187.5 Z  M 177.966 187.5 C 177.966 182.238 182.238 177.966 187.5 177.966 C 192.762 177.966 197.034 182.238 197.034 187.5 C 197.034 192.762 192.762 197.034 187.5 197.034 C 182.238 197.034 177.966 192.762 177.966 187.5 Z "
                  fillRule="evenodd"
                  fill="rgb(5,4,9)"
                />
                <path
                  d=" M 6.356 187.5 C 6.356 87.524 87.524 6.356 187.5 6.356 C 287.476 6.356 368.644 87.524 368.644 187.5 C 368.644 287.476 287.476 368.644 187.5 368.644 C 87.524 368.644 6.356 287.476 6.356 187.5 Z  M 177.966 187.5 C 177.966 182.238 182.238 177.966 187.5 177.966 C 192.762 177.966 197.034 182.238 197.034 187.5 C 197.034 192.762 192.762 197.034 187.5 197.034 C 182.238 197.034 177.966 192.762 177.966 187.5 Z "
                  fillRule="evenodd"
                  fill="rgb(11,9,22)"
                  vectorEffect="non-scaling-stroke"
                  strokeWidth="2"
                  stroke="rgb(5,4,9)"
                  strokeLinejoin="miter"
                  strokeLinecap="square"
                  strokeMiterlimit="3"
                />
                <path
                  d=" M 31.78 187.5 C 31.78 101.556 101.556 31.78 187.5 31.78 C 273.444 31.78 343.22 101.556 343.22 187.5 C 343.22 273.444 273.444 343.22 187.5 343.22 C 101.556 343.22 31.78 273.444 31.78 187.5 Z "
                  fill="none"
                  vectorEffect="non-scaling-stroke"
                  strokeWidth="0.5"
                  stroke="rgb(5,4,9)"
                  strokeLinejoin="miter"
                  strokeLinecap="square"
                  strokeMiterlimit="3"
                />
                <path
                  d=" M 18 187.5 C 18 93.95 93.95 18 187.5 18 C 281.05 18 357 93.95 357 187.5 C 357 281.05 281.05 357 187.5 357 C 93.95 357 18 281.05 18 187.5 Z "
                  fill="none"
                  vectorEffect="non-scaling-stroke"
                  strokeWidth="0.5"
                  stroke="rgb(5,4,9)"
                  strokeLinejoin="miter"
                  strokeLinecap="square"
                  strokeMiterlimit="3"
                />
                <path
                  d=" M 58.792 187.5 C 58.792 116.464 116.464 58.792 187.5 58.792 C 258.536 58.792 316.208 116.464 316.208 187.5 C 316.208 258.536 258.536 316.208 187.5 316.208 C 116.464 316.208 58.792 258.536 58.792 187.5 Z "
                  fill="none"
                  vectorEffect="non-scaling-stroke"
                  strokeWidth="0.5"
                  stroke="rgb(5,4,9)"
                  strokeLinejoin="miter"
                  strokeLinecap="square"
                  strokeMiterlimit="3"
                />
                <path
                  d=" M 45 187.5 C 45 108.852 108.852 45 187.5 45 C 266.148 45 330 108.852 330 187.5 C 330 266.148 266.148 330 187.5 330 C 108.852 330 45 266.148 45 187.5 Z "
                  fill="none"
                  vectorEffect="non-scaling-stroke"
                  strokeWidth="0.5"
                  stroke="rgb(5,4,9)"
                  strokeLinejoin="miter"
                  strokeLinecap="square"
                  strokeMiterlimit="3"
                />
                <path
                  d=" M 88.983 187.5 C 88.983 133.127 133.127 88.983 187.5 88.983 C 241.873 88.983 286.017 133.127 286.017 187.5 C 286.017 241.873 241.873 286.017 187.5 286.017 C 133.127 286.017 88.983 241.873 88.983 187.5 Z "
                  fill="none"
                  vectorEffect="non-scaling-stroke"
                  strokeWidth="0.5"
                  stroke="rgb(0,0,0)"
                  strokeLinejoin="miter"
                  strokeLinecap="square"
                  strokeMiterlimit="3"
                />
                <path
                  d=" M 102 187.5 C 102 140.311 140.311 102 187.5 102 C 234.689 102 273 140.311 273 187.5 C 273 234.689 234.689 273 187.5 273 C 140.311 273 102 234.689 102 187.5 Z "
                  fill="none"
                  vectorEffect="non-scaling-stroke"
                  strokeWidth="0.5"
                  stroke="rgb(0,0,0)"
                  strokeLinejoin="miter"
                  strokeLinecap="square"
                  strokeMiterlimit="3"
                />
                <path
                  d=" M 74 187.5 C 74 124.858 124.858 74 187.5 74 C 250.142 74 301 124.858 301 187.5 C 301 250.142 250.142 301 187.5 301 C 124.858 301 74 250.142 74 187.5 Z "
                  fill="none"
                  vectorEffect="non-scaling-stroke"
                  strokeWidth="0.5"
                  stroke="rgb(0,0,0)"
                  strokeLinejoin="miter"
                  strokeLinecap="square"
                  strokeMiterlimit="3"
                />
              </g>
              <path
                d=" M 175.737 187.5 L 113 187.5 C 113 228.618 146.382 262 187.5 262 C 228.618 262 262 228.618 262 187.5 L 199.263 187.5 L 199.263 187.5 C 199.263 193.992 193.992 199.263 187.5 199.263 C 181.008 199.263 175.737 193.992 175.737 187.5 L 175.737 187.5 Z "
                fill="rgb(215,215,215)"
              />
              <path
                d=" M 199.263 187.5 L 262 187.5 C 262 146.382 228.618 113 187.5 113 C 146.382 113 113 146.382 113 187.5 L 175.737 187.5 C 175.737 181.008 181.008 175.737 187.5 175.737 C 193.992 175.737 199.263 181.008 199.263 187.5 Z "
                fill="rgb(255,255,255)"
              />
              <mask id="_mask_wUQ0brZnXiIoGP3fXI8OZnrtYPre8tt5">
                <circle
                  vectorEffect="non-scaling-stroke"
                  cx="187.49999999999994"
                  cy="187.49999999999994"
                  r="74.5"
                  fill="white"
                  stroke="none"
                />
              </mask>
              <circle
                vectorEffect="non-scaling-stroke"
                cx="187.49999999999994"
                cy="187.49999999999994"
                r="74.5"
                fill="none"
              />
              <linearGradient id="_lgradient_5" x1="0" y1="0.5" x2="1" y2="0.5">
                <stop offset="0%" stopOpacity="1" stopColor={color1} />
                <stop offset="100%" stopOpacity="1" stopColor={color2} />
              </linearGradient>
              <circle
                vectorEffect="non-scaling-stroke"
                cx="187.49999999999994"
                cy="187.49999999999994"
                r="74.5"
                fill="none"
                mask="url(#_mask_wUQ0brZnXiIoGP3fXI8OZnrtYPre8tt5)"
                strokeWidth="10"
                stroke="url(#_lgradient_5)"
                strokeLinejoin="miter"
                strokeLinecap="square"
                strokeMiterlimit="3"
              />
              <clipPath id="_clipPath_OkqVdZNiMTWbJ47ahVGTK6CatwDev6mF">
                <rect
                  x="148.362"
                  y="137.538"
                  width="78.276"
                  height="25.424"
                  transform="matrix(1,0,0,1,0,0)"
                  fill="rgb(255,255,255)"
                />
              </clipPath>
              <g clipPath="url(#_clipPath_OkqVdZNiMTWbJ47ahVGTK6CatwDev6mF)">
                <g>
                  <g>
                    <path
                      d=" M 162.991 151.191 L 162.991 151.191 L 162.991 150.387 L 165.268 149.976 L 165.268 151.089 L 165.268 151.089 Q 165.285 151.996 165.738 152.45 L 165.738 152.45 L 165.738 152.45 Q 166.192 152.903 166.945 152.903 L 166.945 152.903 L 166.945 152.903 Q 167.681 152.903 168.118 152.424 L 168.118 152.424 L 168.118 152.424 Q 168.554 151.945 168.554 151.14 L 168.554 151.14 L 168.554 142.752 L 170.917 142.752 L 170.917 151.14 L 170.917 151.14 Q 170.917 152.818 169.804 153.982 L 169.804 153.982 L 169.804 153.982 Q 168.691 155.146 166.962 155.146 L 166.962 155.146 L 166.962 155.146 Q 165.165 155.146 164.078 154.059 L 164.078 154.059 L 164.078 154.059 Q 162.991 152.972 162.991 151.191 Z  M 181.085 154.889 L 178.911 154.889 L 178.911 154.889 Q 178.842 154.547 178.842 153.982 L 178.842 153.982 L 178.842 153.982 Q 178.517 154.547 177.875 154.829 L 177.875 154.829 L 177.875 154.829 Q 177.233 155.112 176.514 155.112 L 176.514 155.112 L 176.514 155.112 Q 175.025 155.112 174.169 154.161 L 174.169 154.161 L 174.169 154.161 Q 173.313 153.211 173.313 151.791 L 173.313 151.791 L 173.313 146.467 L 175.59 146.467 L 175.59 151.328 L 175.59 151.328 Q 175.59 152.082 175.984 152.552 L 175.984 152.552 L 175.984 152.552 Q 176.377 153.023 177.13 153.023 L 177.13 153.023 L 177.13 153.023 Q 177.867 153.023 178.294 152.57 L 178.294 152.57 L 178.294 152.57 Q 178.722 152.116 178.722 151.363 L 178.722 151.363 L 178.722 146.467 L 180.999 146.467 L 180.999 153.365 L 180.999 153.365 Q 180.999 154.17 181.085 154.889 L 181.085 154.889 L 181.085 154.889 Z  M 188.617 146.467 L 191.595 146.467 L 188.223 150.01 L 191.664 154.889 L 188.873 154.889 L 186.648 151.671 L 185.707 152.664 L 185.707 154.889 L 183.43 154.889 L 183.43 142.496 L 185.707 142.496 L 185.707 149.6 L 188.617 146.467 L 188.617 146.467 Z  M 195.276 146.467 L 195.276 154.889 L 192.999 154.889 L 192.999 146.467 L 195.276 146.467 L 195.276 146.467 Z  M 192.725 143.711 L 192.725 143.711 L 192.725 143.711 Q 192.725 143.129 193.136 142.709 L 193.136 142.709 L 193.136 142.709 Q 193.547 142.29 194.129 142.29 L 194.129 142.29 L 194.129 142.29 Q 194.711 142.29 195.122 142.701 L 195.122 142.701 L 195.122 142.701 Q 195.532 143.112 195.532 143.711 L 195.532 143.711 L 195.532 143.711 Q 195.532 144.276 195.122 144.687 L 195.122 144.687 L 195.122 144.687 Q 194.711 145.097 194.129 145.097 L 194.129 145.097 L 194.129 145.097 Q 193.547 145.097 193.136 144.687 L 193.136 144.687 L 193.136 144.687 Q 192.725 144.276 192.725 143.711 Z  M 201.609 144.378 L 201.609 144.378 L 201.609 144.378 Q 201.13 144.378 200.779 144.644 L 200.779 144.644 L 200.779 144.644 Q 200.428 144.909 200.428 145.543 L 200.428 145.543 L 200.428 146.467 L 202.328 146.467 L 202.328 148.418 L 200.428 148.418 L 200.428 154.889 L 198.134 154.889 L 198.134 148.418 L 196.731 148.418 L 196.731 146.467 L 198.134 146.467 L 198.134 145.508 L 198.134 145.508 Q 198.134 144.087 198.965 143.232 L 198.965 143.232 L 198.965 143.232 Q 199.795 142.376 201.198 142.376 L 201.198 142.376 L 201.198 142.376 Q 201.952 142.376 202.328 142.547 L 202.328 142.547 L 202.328 144.464 L 202.328 144.464 Q 202.037 144.378 201.609 144.378 Z  M 212 146.467 L 206.711 158.21 L 204.297 158.21 L 206.283 153.828 L 202.705 146.467 L 205.255 146.467 L 207.498 151.397 L 209.569 146.467 L 212 146.467 L 212 146.467 Z "
                      fillRule="evenodd"
                      fill={color2}
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

export default withTheme(VinylSpinner);
